import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { QuizWorkflowStepApiModel, MoveRelatedApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class QuizWorkflowStepsService extends CrudService<QuizWorkflowStepApiModel, number> {
  public apiUrl = 'quiz-workflow-steps';

  public add(model: QuizWorkflowStepApiModel): Observable<QuizWorkflowStepApiModel> {
    return super.add(model).pipe(map((response) => new QuizWorkflowStepApiModel().deserialize(response)));
  }

  public update(model: QuizWorkflowStepApiModel): Observable<QuizWorkflowStepApiModel> {
    return super.update(model).pipe(map((response) => new QuizWorkflowStepApiModel().deserialize(response)));
  }

  public move(model: MoveRelatedApiModel<number, number>): Observable<void> {
    return super.move(model);
  }
}
